import { Box, Typography, useTheme } from "@mui/material";
import { DragAndDropIcon } from "~components/Icons";

interface Props {
  isFileOnDropzone: boolean;
}

const OverlayDragAndDrop = ({ isFileOnDropzone }: Props) => {
  const theme: any = useTheme();
  const styles = {
    wrapper: {
      position: "fixed",
      height: "100vh",
      width: "100vw",
      left: 0,
      top: 0,
      zIndex: 5,
      transition: "opacity 0.4s ease-in-out, visibility 0.4s ease-in-out",
      backgroundColor: "rgba(0, 0, 0, 0.6)",
      opacity: isFileOnDropzone ? 1 : 0,
      visibility: isFileOnDropzone ? "visible" : "hidden",
    },
    content: {
      position: "fixed",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      textAlign: "center",
    },
  };

  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.content}>
        <DragAndDropIcon style={{ width: "60px", height: "60px" }} />
        <Typography sx={{ color: theme.palette.grey[0], marginTop: "8px" }} variant="h4">
          solte seu arquivo aqui
        </Typography>
      </Box>
    </Box>
  );
};

export default OverlayDragAndDrop;
